import React from 'react'
import './LoadingAnimation.sass'
// Importing SVG files
import { ReactComponent as WSlogo } from 'img/logo/ws-no_border_grey.svg'

/**
 * Rendering AnimLoading component.
 * 
 * @export default
 * @class AnimLoading
 * @extends {React.Component}
 */
export default class AnimLoading extends React.Component {
    static defaultProps = {
        className: '',
        color: 'grey' // black, white, grey
    }
    render(){
        return  <div className={`anim_loading d-flex align-items-center justify-content-center ${this.props.className} color-${this.props.color}`} 
                     style={this.props.animationChildrenContainerStyle || this.props.style}
                     onClick={this.props.onClick}>
                    <div style={this.props.animationChildrenInnerContainerStyle}>
                    {this.props.childrenOnly === true ? null : 
                        <div className="container-animation">
                            <div className="logo">
                                {this.props.symbol == null
                                    ? <WSlogo id="ws-no_border_grey"/>
                                    : this.props.symbol}
                            </div>
                            <div className={`loader ${this.props.thin ? 'thin' : ''} ${this.props.inactive?'inactive':''}`} style={this.props.style}></div>
                        </div>
                    }
                        <div className="container-children" style={{textAlign: 'center'}}>
                            {this.props.children
                                ? this.props.children
                                : this.props.textLoading
                                    ? this.props.textLoading
                                    : null}
                        </div>
                    </div>
                </div>
    }
}